import Vue from 'vue'
import Resource from 'vue-resource'
import store from '@/store'
Vue.use(Resource)

export default {
	getById (id) {
		return new Promise(function (resolve, reject) {
			Vue.http.get(store.state.apiURL + '/v1/payments/' + id + '?expand=company,manager,product', {}).then(function (response) {
				resolve(response)
			}, function (response) {
				reject(response)
			})
		})
	},
	update (id, data) {
		return new Promise(function (resolve, reject) {
			Vue.http.put(store.state.apiURL + '/v1/payments/' + id, data).then(function (response) {
				resolve(response)
			}, function (response) {
				reject(response)
			})
		})
	},
	create (data) {
		return new Promise(function (resolve, reject) {
			Vue.http.post(store.state.apiURL + '/v1/payments', data).then(function (response) {
				resolve(response.body)
			}, function (response) {
				reject(response)
			})
		})
	},
	delete (id) {
		return new Promise(function (resolve, reject) {
			Vue.http.delete(store.state.apiURL + '/v1/payments/' + id).then(function (response) {
				resolve(response)
			}, function (response) {
				reject(response)
			})
		})
	}
}



// WEBPACK FOOTER //
// ./src/api/modules/payment/payment.js